import { __extends } from "tslib";
import Manager from "../Abstracts/Manager";
import Application from '../../../Architecture/Core/Application';
var ToastManager = /** @class */ (function (_super) {
    __extends(ToastManager, _super);
    function ToastManager() {
        var _this = _super.call(this) || this;
        _this.list = [];
        return _this;
    }
    ToastManager.prototype.showToast = function (element, startCallback, time, endCallback) {
        var _this = this;
        this.list.push(element);
        Application.current.setState({ toastVisible: true, toast: this.list });
        startCallback != undefined && startCallback();
        setTimeout(function () { return _this.closeToast(endCallback); }, time);
    };
    ToastManager.prototype.closeToast = function (callBack) {
        this.list.pop();
        Application.current.setState({ toastVisible: this.list.length != 0, toast: this.list }, callBack != undefined ? callBack : function () { });
    };
    return ToastManager;
}(Manager));
export default ToastManager;
